export default __webpack_public_path__ + "Healthy-Weight-your-Child-Colored.svg";